import { remark } from "remark";
import html from "remark-html";
import remarkGfm from "remark-gfm";

export async function parseMarkdown(content: string) {
  // Convert markdown to HTML string
  const processedContent = await remark()
    .use(html)
    .use(remarkGfm)
    .process(content);

  return processedContent.toString();
}
